// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3d3oU","tab":"ProcedureTabs_tab__2FqNF"};